module.exports = "<aside class=\"aside-menu\">\n  \n</aside>\n"